import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, Form } from 'react-final-form';
import { Col } from 'react-bootstrap';
import CryptoJS from 'crypto-js';
import {
  Card, CardBody,
} from '@/shared/components/Card';
import {
  FormButtonToolbar,
  FormContainer,
  FormGroup,
  FormGroupField,
  FormGroupLabel,
  FormHalfContainer,
 
} from '@/shared/components/form/FormElements';
import { renderMaskedField } from '@/shared/components/form/FormField';
import Select from 'react-select';
import CircularProgress from '@mui/material/CircularProgress';
import { Button } from '@/shared/components/Button';
import { GlobalContext } from '../../../context/GlobalContext';
import { AuthContext } from '../../../context/AuthContext';

const EditProfile = ({
 formValues, onSubmit, buttonDiabled, setShowEditModal, 
}) => {
  const { apiGlobal } = useContext(GlobalContext);
  const path = `${apiGlobal}/images/agent/`;
  const gstpath = `${apiGlobal}/images/agent/GST/`;
  const [selectedImage, setSelectedImage] = useState(path + formValues.logo);
  const [selectedAdressProof, setSelectedAdressProof] = useState(gstpath + formValues.address_proof_file);
  const [selectedGstProof, setSelectedGSTProof] = useState(gstpath + formValues.gst_proof_file);
  const [country, setCountry] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { setCurrencyType, SetCurrencyCode } = useContext(AuthContext);
  const [selectCountry, setSelectCountry] = useState(null);

  const validateGSTIN = (value) => {
  if (!value) return 'GST No is required';
  const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  if (!gstinRegex.test(value.toUpperCase())) {
    return 'Invalid GST No format';
  }
  return undefined;
};

  const handleFileChange = (event, input) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result); 
      };
      reader.readAsDataURL(file);
      input.onChange(file); 
    } else {
      setSelectedImage(null); 
      input.onChange(null); 
    }
  };

  const handAddressFileChange = (event, input) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedAdressProof(reader.result);
      };
      reader.readAsDataURL(file);
      input.onChange(file);
    } else {
      setSelectedAdressProof(null);
      input.onChange(null);
    }
  };


  const handGstFileChange = (event, input) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedGSTProof(reader.result);
      };
      reader.readAsDataURL(file);
      input.onChange(file);
    } else {
      setSelectedGSTProof(null);
      input.onChange(null);
    }
  };

  const fetchCountryList = async () => {
      setIsLoading(true);
        try {
          const url = await fetch(`${apiGlobal}/currency_master_list.php`, {
          method: 'POST',
        });
          const response = await url.json();
          if (response.status && response.message === 'Success') {
            setCountry(response?.data);
          } else {
            setCountry([]);
          }
        } catch (error) {
          console.log(error);
        } finally {
          setIsLoading(false);
          setSelectCountry({
            value: formValues.country,
            label: formValues.country_name,
          });
        }
      };
    
      useEffect(() => {
        fetchCountryList();
      }, []);

  //      const handleCurrencyChange = (option) => {
  //   // Encrypt selected currency before storing

  //   SetCurrencyCode(option.country_code);
  //   setCurrencyType(option.value);
  //   const encryptedCurrencyType = CryptoJS.AES
  //     .encrypt(JSON.stringify(option.value), 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2')
  //     .toString();
  //   const encryptedCurrency = CryptoJS.AES
  //     .encrypt(JSON.stringify(option.country_code), 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2')
  //     .toString();

  //   localStorage.setItem('78582826978678984898069', encryptedCurrencyType);
  //   localStorage.setItem('99117114114101110991219599111100101', encryptedCurrency);
  // };

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <Form onSubmit={onSubmit} initialValues={formValues}>
            {({ handleSubmit }) => (
              <FormContainer onSubmit={handleSubmit}>
                <FormHalfContainer>
                 
                  <FormGroup>
                    <FormGroupLabel>Agent Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="name"
                        component="input"
                        type="text"
                        placeholder="Agent Name"
                        required
                        style={{ height: '45px' }}
                      />
                    </FormGroupField>
                  </FormGroup>
                  <FormGroup>
                    <FormGroupLabel>Address Line 1<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="address1"
                        component="input"
                        type="text"
                        placeholder="Address Line 1"
                        required
                        style={{ height: '45px' }}
                      />
                    </FormGroupField>
                  </FormGroup>
                  <FormGroup>
                    <FormGroupLabel>Area<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="area"
                        component="input"
                        type="text"
                        placeholder="Area"
                        required
                        style={{ height: '45px' }}
                      />
                    </FormGroupField>
                  </FormGroup>
                  <FormGroup>
                    <FormGroupLabel>State<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="state"
                        component="input"
                        type="text"
                        placeholder="State"
                        required
                        style={{ height: '45px' }}
                      />
                    </FormGroupField>
                  </FormGroup>
                  <FormGroup>
                    <FormGroupLabel>Pincode<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="pincode"
                        component="input"
                        type="number"
                        inputMode="numeric" // mobile-friendly numeric keyboard
                            // pattern="\d{1,12}"
                        maxLength={12} // limit to 15 digits
                        onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 6);
                          }}
                        placeholder="Pincode"
                        required
                        style={{ height: '45px' }}
                      />
                    </FormGroupField>
                  </FormGroup>
                  <FormGroup>
                    <FormGroupLabel>Logo</FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="file"
                        render={({ input }) => (
                          <input
                            type="file"
                            onChange={e => handleFileChange(e, input)}
                          />
                        )}
                        style={{ height: '45px' }}
                      />
                    </FormGroupField>
                  </FormGroup>
                  {selectedImage && (
                    <FormGroup>
                      <FormGroupLabel>Selected Logo</FormGroupLabel>
                      <FormGroupField>
                        <img
                          src={selectedImage}
                          alt="Selected Logo"
                          style={{ maxWidth: '200px', maxHeight: '200px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  )}
                  <FormGroup>
                    <FormGroupLabel>GST No</FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="gst_no"
                        component="input"
                        type="text"
                        placeholder="GST No"
                        maxLength={15}
                        parse={value => value?.toUpperCase()} // Auto-uppercase
                        // validate={validateGSTIN}
                        style={{ height: '45px' }}
                      />
                    </FormGroupField>
                  </FormGroup>
                  <FormGroup>
                    <FormGroupLabel>GST Type</FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="gst_type"
                        component="input"
                        type="text"
                        placeholder="GST Type"
                        style={{ height: '45px' }}
                      />
                    </FormGroupField>
                  </FormGroup>
                  <FormGroup>
                    <FormGroupLabel>Address Proof</FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="addressProof"
                        render={({ input }) => (
                          <input
                            type="file"
                            onChange={e => handAddressFileChange(e, input)}
                          />
                        )}
                        style={{ height: '45px' }}
                      />
                    </FormGroupField>
                  </FormGroup>
                  {selectedAdressProof !== gstpath
? (
  <FormGroup>
    <FormGroupLabel>Selected Address Proof</FormGroupLabel>
    <FormGroupField>
      <img
        src={selectedAdressProof}
        alt="Selected Address Proof"
        style={{ maxWidth: '200px', maxHeight: '200px' }}
      />
    </FormGroupField>
  </FormGroup>
) : (
  <div>
    <span style={{ color: 'red' }}>
      No Prior Address Proof Upload
    </span>
  </div>
)}
          
                  <FormGroup>
                    <FormGroupLabel>GST Proof</FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="gstProof"
                        render={({ input }) => (
                          <input
                            type="file"
                            onChange={e => handGstFileChange(e, input)}
                          />
                        )}
                        style={{ height: '45px' }}
                      />
                    </FormGroupField>
                  </FormGroup>
                  {selectedGstProof !== gstpath ? (
                    <FormGroup>
                      <FormGroupLabel>Selected GST Proof</FormGroupLabel>
                      <FormGroupField>
                        <img
                          src={selectedGstProof}
                          alt="Selected Address Proof"
                          style={{ maxWidth: '200px', maxHeight: '200px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  ) : (
                    <div>
                      <span style={{ color: 'red' }}>
                        No Prior Gst Proof Upload
                      </span>
                    </div>
                  ) }
                 
                </FormHalfContainer>
                <FormHalfContainer>
                  <FormGroup>
                    <FormGroupLabel>UAN<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="uan"
                        component="input"
                        type="number"
                        inputMode="numeric" // mobile-friendly numeric keyboard
                            // pattern="\d{1,12}"
                        maxLength={12} // limit to 15 digits
                        onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12);
                          }}
                        placeholder="UAN"
                        required
                        style={{ height: '45px' }}
                      />
                    </FormGroupField>
                  </FormGroup>
                  <FormGroup>
                    <FormGroupLabel>Address Line 2</FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="address2"
                        component="input"
                        type="text"
                        placeholder="Address Line 2"
                        style={{ height: '45px' }}
                      />
                    </FormGroupField>
                  </FormGroup>
                  <FormGroup>
                    <FormGroupLabel>City<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="city"
                        component="input"
                        type="text"
                        placeholder="City"
                        required
                        style={{ height: '45px' }}
                      />
                    </FormGroupField>
                  </FormGroup>
                  <FormGroup>
                    <FormGroupLabel>country<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <FormGroupField>
                      {/* <Field
                        name="country"
                        render={({ input }) => (
                          <Select
                            {...input}
                            name="country"
                            className="react-select w-100"
                            classNamePrefix="react-select"
                            value={selectCountry}
                            onChange={(selected) => {
                              setSelectCountry(selected);
                              input.onChange(selected.value);
                            }}
                            isDisabled
                            options={country.map(item => ({
                                value: item.id,
                                label: item.country_name,
                                // country_code: item.country_code,
                              }))}
                          //   onChange={(selected) => {
                          //    setLocationsNames(selected); 
                          //    input.onChange(selected);
                          //  }}
                            isClearable 
                            placeholder="Select a Location"
                            required
                            
                          />
                          
                       )}
                        // name="country"
                        // component="input"
                        // type="text"
                        // placeholder="Country"
                        // required

                      /> */}
                      <Field
                        name="country_name"
                        component="input"
                        type="text"
                        placeholder="country"
                        required
                        readOnly
                        style={{ height: '45px' }}
                      />
                    </FormGroupField>
                  </FormGroup>
                  <FormGroup>
                    <FormGroupLabel>Location<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="location"
                        component="input"
                        type="text"
                        placeholder="Location"
                        required
                        style={{ height: '45px' }}
                      />
                    </FormGroupField>
                  </FormGroup>
                  <FormGroup>
                    <FormGroupLabel>Default Markup<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="markup"
                        component="input"
                        type="number"
                        inputMode="numeric" // mobile-friendly numeric keyboard
                        maxLength={12} 
                        onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 3);
                            if (e.target.value > 100) {
                              e.target.value = 100; // Limit to 100%
                            } 
                          }}
                        placeholder="Default Markup"
                        required
                        style={{ height: '45px' }}
                      />
                    </FormGroupField>
                  </FormGroup>
                  <FormGroup>
                    <FormGroupLabel>TAX Identification<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="tax_id"
                        component="input"
                        type="text"
                        placeholder="Tax Identification"
                        required
                        style={{ height: '45px' }}
                      />
                    </FormGroupField>
                  </FormGroup>
                  <FormGroup>
                    <FormGroupLabel>TAX City<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="tax_city"
                        component="input"
                        type="text"
                        placeholder="Tax City"
                        required
                        style={{ height: '45px' }}
                      />
                    </FormGroupField>
                  </FormGroup>
                  <FormGroup>
                    <FormGroupLabel>Credit Upper Limit</FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="upper_limit"
                        component="input"
                        type="text"
                        placeholder="credit upper Limit"
                        disabled
                      />
                    </FormGroupField>
                  </FormGroup>
                  
                </FormHalfContainer>
                <FormButtonToolbar>
                  <Button type="button" variant="danger" onClick={() => setShowEditModal(false)}>Close</Button>
                  <Button 
                    variant="primary"
                    disabled={buttonDiabled}
                    type="submit"
                  >
                    
                    {buttonDiabled ? (
                      <div style={{
                    display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', 
                    }}
                      >
                        <CircularProgress />
                      </div>
                    ) : 'Submit'}
                  </Button>

                </FormButtonToolbar>
              </FormContainer>
            )}
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
}; 

EditProfile.propTypes = {
  formValues: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    address1: PropTypes.string,
    address2: PropTypes.string,
    area: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    country: PropTypes.string,
    tax_id: PropTypes.string,
    tax_city: PropTypes.string,
    country_name: PropTypes.string,
    address_proof_file: PropTypes.string,
    gst_proof_file: PropTypes.string,
    gst_no: PropTypes.string,
    gst_type: PropTypes.string,
    markup: PropTypes.string,
    user_name: PropTypes.string,
    user_email: PropTypes.string,
    user_phone: PropTypes.string,
    uin: PropTypes.number,
    acc_name: PropTypes.string,
    account_no: PropTypes.number,
    ifsc_code: PropTypes.string,
    branch: PropTypes.string,
    bank: PropTypes.string,
    acc_city: PropTypes.string,
    logo: PropTypes.string,
    acc_country: PropTypes.string,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  buttonDiabled: PropTypes.bool.isRequired,
  setShowEditModal: PropTypes.func.isRequired,
};

export default EditProfile;
